var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMs = function SvgMs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M11.968 12H12v-.033l-.032.033Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 6.261V.001h-.002C5.371 0 0 5.373 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.787L8.474 6.26H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.071 1.565a12.057 12.057 0 0 0-4.506 4.506v5.93h3.13V4.695H12v-3.13H6.071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 10.524 7.738 6.261H6.262L12 12v-1.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M13.565 6.26V12c0 2.795 3.653 3.652 3.653 3.652S20.87 14.795 20.87 12V6.26h-7.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M13.565 12c0 2.795 3.653 3.651 3.653 3.651S20.87 14.795 20.87 12h-7.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.783 8.87h-1.044V7.825h-1.043v1.043h-1.044v1.044h1.044v3.13h1.043v-3.13h1.044V8.869Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMs;